import { useIntl } from "react-intl";

import { evictCache } from "../../../lib/apollo/utils";
import {
  type ActivityFields,
  ActivityLaborForceType,
  ActivityProgressMeasureType,
  WorkOrderType,
} from "../../../lib/graphql/generated";
import { useActivityCreate } from "../../../lib/hooks/agro/activities";
import { NewForm } from "../../shared/ListView/NewForm";
import { ActivityBasicForm } from "./ActivityBasicForm";

export function NewActivitySidebar({ onClose }: { onClose: () => void }) {
  const intl = useIntl();

  return (
    <NewForm
      entityName={intl.formatMessage({ id: "activities.entityName" })}
      mutation={useActivityCreate}
      onMutate={(result) => result.activityCreate}
      mutationOptions={{ update: evictCache("activities", "onboardingStatus") }}
      onClose={onClose}
      formValues={() =>
        ({
          workOrderType: WorkOrderType.FieldWork,
          workdayHours: 8,
          laborForceType: ActivityLaborForceType.Laborer,
          progressMeasureType: ActivityProgressMeasureType.ByGroup,
        }) as ActivityFields
      }
      fields={[
        {
          type: "custom",
          render: () => <ActivityBasicForm key="activity-form" />,
        },
      ]}
    />
  );
}
